import { Box, Button } from '@mui/material'
import { FormEvent, FormEventHandler } from 'react'
import { useTranslation } from 'react-i18next'
import { useNewPassword } from '../../hooks/useNewPassword'
import { ChangePasswordData } from '../../types/auth'
import { PasswordField } from '../atoms/PasswordField'

export interface ChangePasswordFormProps {
  onSubmit: (data: ChangePasswordData) => void
  label?: string
}

export function ChangePasswordForm(props: ChangePasswordFormProps): React.ReactElement {

  const { t } = useTranslation()
  const newPassword = useNewPassword()

  const onSubmit: FormEventHandler<HTMLFormElement> = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    // Nothing is sent until the password passes the same rule the server applies.
    if (!newPassword.submit()) {
      return
    }

    props.onSubmit({
      password: newPassword.password,
      password_again: newPassword.passwordAgain,
    })
    newPassword.reset()
  }

  return (
    <Box id="change-password" component="form" onSubmit={onSubmit}>
      <PasswordField
        id="password"
        name="password"
        label={t('Password')}
        cy="New password"
        autoComplete="new-password"
        {...newPassword.passwordField}
      />
      <PasswordField
        id="password-again"
        name="password_again"
        label={t('Re-enter password')}
        cy="Re-enter password"
        autoComplete="new-password"
        {...newPassword.passwordAgainField}
      />

      <Button
        type="submit"
        variant="contained"
        fullWidth
        sx={{ mt: 3 }}
        data-cy={`button-${props.label || t('Reset Password')}`}
      >
        {props.label || t('Reset Password')}
      </Button>
  </Box>
  )
}
